(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.finnCommon = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
module.exports={
    "trackjs": {
        "version": "1.0.0",
        "vendor": "https://d2zah9y47r7bi2.cloudfront.net/releases/current/tracker.js"
    }
}

},{}],2:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var WINDOW_KEY = '_trackJsErrorQueue';

if (!Array.isArray(window[WINDOW_KEY])) {
    window[WINDOW_KEY] = [];
    var origOnError = window.onerror || function () {};
    window.onerror = function (e) {
        window[WINDOW_KEY].push(e);

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        origOnError.apply(undefined, [e].concat(args));
    };
}

exports.default = function () {
    return window[WINDOW_KEY];
};

},{}],3:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (metadata) {
    if (!metadata) {
        return 'No ads metadata available.';
    }
    var ads = {};
    for (var property in metadata) {
        if (metadata.hasOwnProperty(property)) {
            if (metadata[property].adResponse && metadata[property].adResponse.ads) {
                var ad = metadata[property].adResponse.ads.slice().shift();
                ads[property] = ad.creative_id;
            }
        }
    }
    return JSON.stringify(ads);
};

},{}],4:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _trackjsSrc = _dereq_('./trackjs-src');

var _trackjsSrc2 = _interopRequireDefault(_trackjsSrc);

var _errorQueue = _dereq_('./error-queue');

var _errorQueue2 = _interopRequireDefault(_errorQueue);

var _extractCreatives = _dereq_('./extract-creatives.js');

var _extractCreatives2 = _interopRequireDefault(_extractCreatives);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ignoreRegExp = new RegExp(['appnexus', 'adform', 'adtech', 'adnxs\\.com', 'meetrics\\.net', 'demdex\\.net', 'revsci\\.net', '\\sawx\\w+\\s', 'mxcdn\\.net', 'adsafeprotected\\.com', 's3\\.amazonaws\\.com', 'serving-sys\\.com', 'atlassbx\\.com'].join('|'));

var defaultConfig = {
    token: '74bb3e28a1604fd2b28c72c568722d21',
    onError: function onError(payload, error) {
        if ((payload.message === "Can't execute code from a freed script" || payload.message === 'Script error.') && navigator.userAgent.indexOf('Edge') > -1) {
            return false;
        }
        if (error && error.stack && ignoreRegExp.test(error.stack.toString())) {
            return false;
        }
        payload.metadata.push({
            key: 'ads-metadata',
            value: (0, _extractCreatives2.default)(window.apntag && window.apntag.requests && window.apntag.requests.tags)
        });
        return true;
    },
    cookie: false,
    enabled: !window.location.host.includes('local')
};

var initiated = false;

exports.default = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (initiated) {
        return;
    }

    var options = Object.assign({}, defaultConfig, window._trackJs, data);
    if (typeof options.application !== 'string') {
        throw new Error('Expected application name as a string, received ' + options.application);
    }

    window._trackJs = options;
    var s = document.createElement('script');
    s.src = _trackjsSrc2.default;
    s.crossorigin = '';
    s.onload = function sendQueuedErrors() {
        (0, _errorQueue2.default)().forEach(sendError);
    };
    document.body.appendChild(s);
    function sendError(e) {
        window.trackJs.console.info('From async loading queue');
        window.trackJs.track(e);
    }

    initiated = true;
};

},{"./error-queue":2,"./extract-creatives.js":3,"./trackjs-src":5}],5:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cdnUrls = _dereq_('../cdn-urls.json');

var _cdnUrls2 = _interopRequireDefault(_cdnUrls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _cdnUrls2.default.trackjs.vendor;

},{"../cdn-urls.json":1}]},{},[4])(4)
});
//# sourceMappingURL=main.js.map
